{
    "coordinates": [
        50.831182824322724,
        12.94285222123031
    ],
    "tooltip": "Chemnitz Petrified Forest",
    "title": "Leukersdorf Formation (Chemnitz Petrified Forest)",
    "country": "Germany",
    "period": "Permian",
    "alt": "TODO"
}
